/**
 * created by li si yi
 * 图标列表
 */
import React, {Component} from 'react';

const iconList = (type) => {
    switch (type) {
        case 'resources': // 资源
            return "IconResource";
        case 'clue': // 线索
            return "PicClues";
        case 'busNewsClue': // 线索
            return "PicClues";
        case 'topic': // 选题
            return "IconTopic";
        case 'busTopicSelection': // 选题
            return "IconTopic";
        case 'reservedStory': // 约稿
            return "Approximations";
        case 'interviewTasks': // 采访任务
            return "IconInterview";
        case 'default': // 通知
            return "IconManuscript";
        case 'inviteStory': // 约稿稿件
            return "IconInviteStory";
        case 'websiteStory': // 网站稿件
            return "WebsiteIcon";
        case 'interviewStory': // 采访稿件
            return "IconInterviewStory";
        case 'contributionStory': // 投稿稿件
            return "ContributeIcon";
        case 'material': // 公众号
            return "OfficialIcon";
        case 'weChatOfficial': // 公众号
            return "OfficialIcon";
        case 'webo': // 微博
            return "MicroblogIcon";
        case 'weibo': // 微博
            return "MicroblogIcon";
        case 'douyin': // 抖音
            return "TikTokIcon";
        case 'kuaishou': // 快手
            return "IconKuaishou";
        case 'mediaAudit': // 媒体备案申请
            return "MediaIcon";
        case 'media': // 媒体备案申请
            return "MediaIcon";
        case 'informationDto': // 新媒体矩阵
            return "NewMediaIcon";
        case 'zyxzsq': // 资源下载申请
            return "DownloadResourcesIcon";
        default :
            return "messageCenterDefault";
    }
}
export default iconList